export default __webpack_public_path__ + "static/media/ImperialOpen.35dc2a7d.jpg";